// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--LEYqw","header":"a10a3f92e9--header--k5uKc","slider":"a10a3f92e9--slider--dNFJ9"};